import styled, { keyframes } from 'styled-components';
import Variables from 'styles/Variables';

export const TicketWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 0.5rem;
	padding: 1rem 0;
`;

export const TicketInfo = styled.div`
	flex-grow: 1;
	margin-right: 1rem;
`;

export const Attendee = styled.p`
	font-weight: 600;
	margin-bottom: 0.25rem;
`;

export const Code = styled.span`
	text-transform: uppercase;
`;

export const BoldText = styled.span`
	font-weight: 600;
`;

export const Text = styled.p`
	font-size: 0.875rem;
	margin-bottom: 0.125rem;
`;

export const Small = styled.p`
	font-size: 0.65rem;
`;

export const TicketActions = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 0.5rem;
	flex-shrink: 0;
`;

export const PreviewTicket = styled.button`
	color: ${Variables.colors.main};
	display: grid;
	grid-auto-flow: column;
	grid-gap: 0.5rem;
	cursor: pointer;
	border: none;
	background: none;
	font: inherit;
	padding: 0;
`;

export const DownloadTicket = styled.button`
	color: ${Variables.colors.main};
	display: grid;
    grid-auto-flow: column;
    grid-gap: 0.5rem;
`;

export const TransferTicket = styled.button`
	color: ${Variables.colors.main};
	display: grid;
	grid-auto-flow: column;
	grid-gap: 0.5rem;
	cursor: pointer;
	border: none;
	background: none;
	font: inherit;
	padding: 0;
`;

export const TransferBadge = styled.span`
	color: #b8860b;
	font-size: 0.8rem;
	font-weight: 600;
	white-space: nowrap;
`;

export const TransferredBadge = styled.span`
	align-items: center;
	background: ${Variables.colors.success};
	border-radius: 0.75rem;
	color: #fff;
	display: inline-flex;
	font-size: 0.7rem;
	font-weight: 600;
	letter-spacing: 0.02em;
	padding: 0.3rem 0.7rem;
	text-transform: uppercase;
	white-space: nowrap;

	&[data-direction='OUTGOING'] {
		background: ${Variables.colors.danger};
	}
`;

export const HistoryToggle = styled.button`
	color: ${Variables.colors.main};
	display: grid;
	grid-auto-flow: column;
	grid-gap: 0.375rem;
	align-items: center;
	cursor: pointer;
	border: none;
	background: none;
	font: inherit;
	font-size: 0.8rem;
	padding: 0;
`;

export const TransferLine = styled.p`
	color: #8c8c8c;
	font-size: 0.8rem;
	margin-top: 0.6rem;
	width: 100%;
`;

export const CancelTransfer = styled.button`
	color: #9b1c1c;
	font-size: 0.8rem;
	cursor: pointer;
	border: none;
	background: none;
	font-family: inherit;
	padding: 0;
	white-space: nowrap;

	&:disabled {
		opacity: 0.6;
		cursor: default;
	}
`;

export const Downloading = styled.p`
	color: ${Variables.colors.main};
	font-size: 0.875rem;
	padding-right: 1.25rem;
	position: relative;

	&:after {
		animation: ${rotationBuilder()} 1.5s linear infinite forwards;
		border-radius: 50%;
		border: 3px solid transparent;
		border-top-color: ${Variables.colors.main};
		content: '';
		height: 0.625rem;
		margin-left: 0.375rem;
		position: absolute;
		width: 0.625rem;
	}
`;

function rotationBuilder() {
	const rotation = keyframes`
		0% { transform: rotate(0deg) }
		100% { transform: rotate(360deg) }
	`;
	return rotation;
}
